// fields/SchemaField.js
import React, { useState } from "react";
import { Form, Input, Alert } from "antd";

const { TextArea } = Input;

const SchemaField = ({
  name = "additional_schema",
  label = "Additional Schema (JSON)",
  required = false,
}) => {
  const [jsonError, setJsonError] = useState(null);

  const validateJson = (value) => {
    if (!value) {
      setJsonError(null);
      return;
    }

    try {
      JSON.parse(value);
      setJsonError(null);
    } catch (error) {
      setJsonError("Invalid JSON format");
    }
  };

  const handleChange = (e) => {
    validateJson(e.target.value);
  };

  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        { required, message: `${label} is required.` },
        {
          validator: (_, value) => {
            if (!value) return Promise.resolve();

            try {
              JSON.parse(value);
              return Promise.resolve();
            } catch (error) {
              return Promise.reject(
                new Error("Additional schema must be valid JSON")
              );
            }
          },
        },
      ]}
      help={jsonError && <Alert message={jsonError} type="error" showIcon />}
    >
      <TextArea
        placeholder='{"@type": "Product", "name": "Example"}'
        onChange={handleChange}
        rows={6}
        style={{ fontFamily: "monospace" }}
      />
    </Form.Item>
  );
};

export default SchemaField;
